// extracted by mini-css-extract-plugin
export default {"Container":"DateTooltip_Container__zA9ZY","Tooltip":"DateTooltip_Tooltip__QUdXF"};